import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Parameter } from './parameter.interface';

@Component({
    selector: 'dmp-parameter',
    templateUrl: './parameter.component.html',
    styleUrls: ['./parameter.component.scss'],
    standalone: false
})
export class ParameterComponent implements OnInit {
  @Input() parameter: Parameter;

  @Output() onSelect = new EventEmitter<{parameter: string, value: string}>();
  selected = '';

  selectParameter(): void {
    this.onSelect.emit({parameter: this.parameter.code, value: this.selected});
  }

  ngOnInit(): void {
    this.selected = this.parameter.defaultValue;
  }

}
